// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"52644556","112":"a8de15d7","159":"fc807390","265":"f752a24e","404":"b49612f9","475":"46578931","659":"17973789","746":"62b12deb","793":"becf7526","877":"8a28c3cf","907":"cc3d44c5","977":"bcca5953"}[chunkId] + ".chunk.js";
};